import { useEffect, useState } from "react";
import { User } from "vimeo";
import { getUser } from "../vimeoClient";

import { StandardIcon } from "../components/icons/StandardIcon";
import { MenuItemItem } from "prop-types";
import { Avatar, Button, Pop, PopOver } from "@vimeo/iris/components";

interface Props {
    postLogoutRedirectUrl?: string;
}

export function AvatarMenu(props: Props) {
    const [user, setUser] = useState<User>({
        name: "Unknown",
        link: "#",
        uri: "",
    });

    useEffect(() => {
        getUser()
            .then((user) => setUser(user))
            .catch(console.error);
    }, []);

    const icon = !user.pictures ? (
        <StandardIcon iconName="user" svgClass="slds-avatar_medium" />
    ) : (
        <Avatar src={user.pictures.sizes[0].link} alt={user.name} />
    );

    function getOptions() {
        return [
            {
                label: user.name,
                value: "profile",
            },
            {
                label: "Logout",
                value: "logout",
            },
        ];
    }

    function onSelect(item: MenuItemItem) {
        switch (item.value) {
            case "logout":
                (
                    document.getElementById("logoutForm") as HTMLFormElement
                ).submit();
                return;
            case "profile":
                window.open(user.link, "_blank");
                return;
        }
    }

    return (
        <div>
            <form id="logoutForm" action="/logout" method="post">
                <input
                    type="hidden"
                    name="redirectUrl"
                    value={props.postLogoutRedirectUrl || "/"}
                />
            </form>
            <PopOver
                attach="left"
                content={
                    <Pop.List>
                        {getOptions().map((o) => (
                            <Pop.Item key={o.value} onClick={() => onSelect(o)}>
                                {o.label}
                            </Pop.Item>
                        ))}
                    </Pop.List>
                }
            >
                <Button
                    format="secondary"
                    variant="minimal"
                    size="sm"
                    icon={icon}
                />
            </PopOver>
        </div>
    );
}
